import { render, staticRenderFns } from "./LinkNotValid.vue?vue&type=template&id=37982fda&"
import script from "./LinkNotValid.vue?vue&type=script&lang=js&"
export * from "./LinkNotValid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports